import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Button from './Button';

const Navbar = ({ 
  links = [], 
  showMemberArea = true, 
  className = '',
  transparent = false 
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [imageError, setImageError] = useState(false);

  const baseClasses = transparent 
    ? 'bg-transparent' 
    : 'bg-white shadow-sm border-b border-gray-100';

  const classes = `${baseClasses} sticky top-0 z-50 ${className}`;

  const logoSrc = transparent ? '/images/aitech-light.png' : '/images/aitech-dark.png';

  return (
    <nav className={classes}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            {!imageError && (
              <img 
                src={logoSrc}
                alt="Aitech Logo" 
                className="h-10 w-auto mr-3"
                onError={() => setImageError(true)}
              />
            )}
            {imageError && (
              <div>
                <h1 className="text-xl font-bold text-gray-900">
                  <span className="text-primary-600">AI</span>TECH
                </h1>
                <p className="text-xs text-gray-500">Technologies Nigeria</p>
              </div>
            )}
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {links.map((link, index) => (
              <Link
                key={index}
                to={link.to}
                className="text-gray-700 hover:text-primary-600 font-medium transition-colors"
              >
                {link.label}
              </Link>
            ))}
            {showMemberArea && (
              <div className="flex items-center space-x-3">
                <Link
                  to="/register"
                  className="text-gray-700 hover:text-primary-600 font-medium transition-colors"
                >
                  Sign Up
                </Link>
                <Button to="/login" size="sm">
                  Sign In
                </Button>
              </div>
            )}
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 hover:text-primary-600 p-2"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-100">
            <div className="flex flex-col space-y-3">
              {links.map((link, index) => (
                <Link
                  key={index}
                  to={link.to}
                  className="text-gray-700 hover:text-primary-600 font-medium"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {link.label}
                </Link>
              ))}
              {showMemberArea && (
                <div className="flex flex-col space-y-3">
                  <Link
                    to="/register"
                    className="text-gray-700 hover:text-primary-600 font-medium"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Sign Up
                  </Link>
                  <Button to="/login" size="sm" className="w-fit">
                    Sign In
                  </Button>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar; 